import ApiService from '@/common/api.service'

export default {
  state: {
    campuses: [],
    buildings: [],
    lang: localStorage.getItem('language') || 'ar',
  },
  getters: {
    campuses(state) {
      return state.campuses.map(t => ({ id: t.id, title: t.title[state.lang] }))
    },
    buildings(state) {
      return state.buildings.map(t => ({ id: t.id, title: t.title[state.lang] }))
    },
    buildingsExtra(state) {
      return state.buildings
    },
  },
  mutations: {
    setCampuses(state, data) {
      state.campuses = data
    },
    setBuildings(state, data) {
      state.buildings = data
    },
  },
  actions: {
    getCampuses({ state, commit }, payload) {
      if (state.campuses.length && !payload?.force) return
      return ApiService.query('campuses').then(({ data }) => commit('setCampuses', data))
    },
    getBuildings({ state, commit }, payload) {
      if (state.buildings.length && !payload?.force) return
      return ApiService.query('buildings').then(({ data }) => commit('setBuildings', data))
    },
  },
}
